import { render, staticRenderFns } from "./AgreementText.vue?vue&type=template&id=72d86a04&scoped=true&"
import script from "./AgreementText.vue?vue&type=script&lang=js&"
export * from "./AgreementText.vue?vue&type=script&lang=js&"
import style0 from "./AgreementText.vue?vue&type=style&index=0&id=72d86a04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d86a04",
  null
  
)

export default component.exports